import React, { useState } from "react";
import * as API from "lib/apis";
import { SERVICE_CODE } from "../constants";

const LeaveTest = () => {
  const [userKey, setUserKey] = useState("");
  const [memberId, setMemberId] = useState("");
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  if (process.env.REACT_APP_ENVIRONMENT === "prod") {
    return null;
  }

  const handleLeave = () => {
    if (!userKey.trim()) {
      setMessage("userKey를 입력해주세요.");
      return;
    }

    setMessage("");
    setIsLoading(true);

    API.leaveMembership(
      SERVICE_CODE.HANA,
      userKey.trim(),
      memberId.trim(),
      (res) => {
        setIsLoading(false);
        if (!res || !res.success) {
          setMessage(
            res && res.message ? res.message : "탈퇴 요청에 실패했습니다."
          );
          return;
        }
        setMessage("탈퇴 요청 성공.");
      }
    );
  };

  return (
    <div style={{ padding: 20 }}>
      <h3>회원탈퇴 테스트 (개발용, 하나머니)</h3>
      <p style={{ color: "#888" }}>
        prod가 아닌 환경에서만 동작합니다. 버튼을 눌러야만 API가 호출됩니다.
      </p>

      <p>
        <label>
          userKey&nbsp;
          <input
            type="text"
            value={userKey}
            onChange={(e) => setUserKey(e.target.value)}
            placeholder="가입 시 전달받은 userKey"
            style={{ width: 400 }}
          />
        </label>
      </p>

      <p>
        <label>
          memberId&nbsp;
          <input
            type="text"
            value={memberId}
            onChange={(e) => setMemberId(e.target.value)}
            placeholder="가입 시 제휴사가 전달한 memberId"
            style={{ width: 400 }}
          />
        </label>
      </p>

      {message && <p>{message}</p>}

      <button onClick={handleLeave} disabled={isLoading}>
        {isLoading ? "탈퇴 요청 중..." : "탈퇴하기"}
      </button>
    </div>
  );
};

export default LeaveTest;
